import axios from 'axios'
import { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import { useAuth } from '../../AuthContext'
import { Link } from 'react-router-dom'
import Profile from './Profile'
import StudentSolutions from './StudentSolutions'
import moment from 'moment/moment'
import { MagnifyingGlass } from 'react-loader-spinner'
import CustomExam from './CustomExam'
import NeetFlexi from './NEETFlexi'
const today = new Date().toISOString().split("T")[0];

const Nav = () => {
    const [exams, setExams] = useState([])
    const [examsLoading,setExamsLoading]=useState(true)
    const [dynamicExams, setDynamicExams] = useState([]);
    const [dynamicLoading, setDynamicLoading] = useState(false);
    const [dynamicPagination, setDynamicPagination] = useState(null);
    const [currentExamType, setCurrentExamType] = useState('topic-wise');
    const [materials, setMaterials] = useState([])
    const [materialsLoading,setMaterialsLoading]=useState(false)
    const [userData, setUserData] = useState({})
    const [solution, setSolution] = useState([])
    const [questionPaper, setQuestionPaper] = useState([])
    const { user } = useAuth()

    const [selectedCourse, setSelectedCourse] = useState(
        localStorage.getItem("selectedCourse") || "ALL"
    );

    const groupedExams = exams.reduce((acc, e) => {
        const courseName = e.examId?.course?.title || 'Other';

        if (!acc[courseName]) {
            acc[courseName] = [];
        }

        acc[courseName].push(e);
        return acc;
    }, {});

        const courseList = Object.keys(groupedExams);

    const [activeTab, setActiveTab] = useState(
        localStorage.getItem("activeTab") || "pills-home"
    );

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        localStorage.setItem("activeTab", tabId);
    };

    const handleExamTypeChange = (tabId, type) => {
        handleTabChange(tabId);
        localStorage.setItem("examType", type);
        getDynamicExams(type);
    };

    const getDynamicExams = async (typeParam, page = 1, limit = 10) => {
        setDynamicLoading(true);
        try {
            const res = await axios.get(`${baseUrl}/dynamic-exam/history?studentId=${user.id}&type=${typeParam}&page=${page}&limit=${limit}`);
            setDynamicExams(res.data.data);
            setDynamicPagination(res.data.pagination);
            setCurrentExamType(typeParam);
        } catch (err) {
            console.log(err);
        } finally {
            setDynamicLoading(false);
        }
    };


    const getExams = async () => {
        setExamsLoading(true)
        try{
            const res= await axios.get(`${baseUrl}/student/exams?email=${user.email}`)
            setExams(res.data.exams)
        }catch(error){
            console.log(error)
        }finally{
            setExamsLoading(false)
        }
    }
    const getMaterials = async () => {
        setMaterialsLoading(true)
        try {
            const res = await axios.get(`${baseUrl}/student/materials?email=${user.email}`)
            setMaterials(res.data.materials)
        } catch (error) {
            console.log(error)
        } finally {
            setMaterialsLoading(false)
        }
    }

    useEffect(() => {
        if (!user) return;

        getExams();
        getMaterials();

        const savedTab = localStorage.getItem("activeTab") || "pills-home";
        const savedType = localStorage.getItem("examType") || "topic-wise";

        setActiveTab(savedTab);

        if (savedTab === "pills-customExam" || savedTab === "pills-flexi") {
            getDynamicExams(savedType);
        }

        axios.get(`${baseUrl}/student/get-by-email?email=${user.email}`)
            .then(res => { setUserData(res.data) })
            .catch(err => console.log(err))

        axios.get(`${baseUrl}/student/exam/solution?email=${user.email}`)
            .then(res => setSolution(res.data))
            .catch(err => { })

        axios.get(`${baseUrl}/student/exam/question-paper?email=${user.email}`)
            .then(res => setQuestionPaper(res.data))
            .catch(err => console.log(err))

    }, [user])

    return (
        <nav>
            <div style={{ width: '95%', margin: '0 auto', backgroundColor: '#34495E' }}>
                <ul className="nav nav-pills p-3" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link text-white ${activeTab === "pills-home" ? "active" : ""}`}
                            onClick={() => handleTabChange("pills-home")}
                        >
                            Exam</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link text-white ${activeTab === "pills-customExam" ? "active" : ""}`}
                            onClick={() => handleExamTypeChange("pills-customExam", "topic-wise")}
                        >
                            Topic Wise Practice</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link text-white ${activeTab === "pills-flexi" ? "active" : ""}`}
                            onClick={() => handleExamTypeChange("pills-flexi", "neet-flexi")}
                        >
                            NEET Flexi</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link text-white ${activeTab === "pills-material" ? "active" : ""}`}
                            onClick={() => handleTabChange("pills-material")}
                        >
                            Material</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className={`nav-link text-white ${activeTab === "pills-profile" ? "active" : ""}`}
                            onClick={() => handleTabChange("pills-profile")}
                        >
                            Profile</button>
                    </li>
                    {/* <li className="nav-item" role="presentation">
                        <button className="nav-link text-white" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-question-paper" type="button" role="tab" aria-controls="pills-question-paper" aria-selected="false">Question Paper</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link text-white" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-solution" type="button" role="tab" aria-controls="pills-solution" aria-selected="false">Solution</button>
                    </li> */}
                </ul>
            </div>
            <div className="tab-content" id="pills-tabContent" style={{ width: '95%', margin: '0 auto' }}>
                <div className={`tab-pane fade ${activeTab === "pills-home" ? "show active" : ""}`}>
                    <div className='mt-3 mb-3' style={{ overflowX: 'scroll' }}>
                        <div className="mb-3 d-flex align-items-center gap-3">
                            <label className="form-label fw-bold">Course</label>

                            <select
                                className="form-select w-auto"
                                value={selectedCourse}
                                onChange={(e) => {
                                    setSelectedCourse(e.target.value);
                                    localStorage.setItem("selectedCourse", e.target.value); // ✅ cache
                                }}
                            >

                                <option value="ALL">All Courses</option>

                                {courseList.map((course, i) => (
                                    <option key={i} value={course}>
                                        {course}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <table className="table table-bordered table-hover">
                            <thead className="table-light">
                                <tr>
                                    <td>#</td>
                                    <td>Name</td>
                                    <td>Start Date</td>
                                    <td>End Date</td>
                                    <td>Status</td>
                                    <td>Result</td>
                                    <td>Review</td>
                                    <td style={{minWidth:'125px'}}>Question Paper</td>
                                    <td>Solution</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !examsLoading&&exams.length<1&&
                                    <tr><td colSpan={6}><h6>Exams will show once they are assigned to you, please come back later...</h6></td></tr>
                                }
                            {
                                examsLoading&&
                                <tr>
                                    <td colSpan={5}>
                                            <MagnifyingGlass
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="magnifying-glass-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="magnifying-glass-wrapper"
                                                glassColor="#c0efff"
                                                color="#8000df"
                                            />
                                    </td>
                                </tr>
                            }
                                {
                                    !examsLoading &&
                                    (selectedCourse === 'ALL'
                                        ? exams
                                        : groupedExams[selectedCourse] || []
                                    ).map((e, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{e.examId?.examName}</td>
                                            <td>{moment(e.examId?.startDate).format('Do MMM YYYY hh:mm:ss a')}</td>
                                            <td>{moment(e.examId?.endDate).format('Do MMM YYYY hh:mm:ss a')}</td>

                                            <td>
                                                {
                                                    e.attempts < e.examId?.attempts ?
                                                        (e.examId?.endDate > today && e.examId.startDate <= today && <Link to={`/student/${user.email}/exam/${e.examId?._id}`}><button className='btn btn-sm btn-success'>Start</button></Link>) ||
                                                        (e.examId?.startDate > today && <button className='btn btn-sm btn-info'>Yet to Start</button>) ||
                                                        (e.examId?.startDate < today && <button className='btn btn-sm btn-danger'>Expired</button>)
                                                        :
                                                        <span className='btn btn-sm btn-info'>Attempted</span>
                                                }
                                            </td>

                                            <td>
                                                {
                                                    e.attempted ?
                                                        e.examId?.course.type === 'TPT' ?
                                                            <Link to={`/exam/tpt-results/${user.email}/${e.examId?._id}`}>Click</Link> :
                                                            <Link to={`/exam/results/${user.email}/${e.examId?._id}`}>Click</Link>
                                                        :
                                                        <p>NA</p>
                                                }
                                            </td>

                                            <td>
                                                {
                                                    e.attempted ?
                                                        e.examId?.course.type === 'TPT' ?
                                                            <Link to={`/exam/tpt-review/${user.email}/${e.examId?._id}`}>Click</Link> :
                                                            <Link to={`/exam/review/${user.email}/${e.examId?._id}`}>Click</Link>
                                                        :
                                                        <p>NA</p>
                                                }
                                            </td>

                                            <td>
                                                {
                                                    e.attempted || new Date(e.examId?.startDate) < new Date() ? (
                                                        e.examId?.questionPaper ? (
                                                            <Link
                                                                to={{
                                                                    pathname: '/view-solution',
                                                                    search: `?fileUrl=${e.examId.questionPaper}`
                                                                }}
                                                            >
                                                                <button className="btn btn-sm">View</button>
                                                            </Link>
                                                        ) : null
                                                    ) : (
                                                        <p>NA</p>
                                                    )
                                                }
                                            </td>

                                            <td>
                                                {
                                                    e.attempted || new Date(e.examId?.startDate) < new Date() ? (
                                                        e.examId?.solution ? (
                                                            <Link
                                                                to={{
                                                                    pathname: '/view-solution',
                                                                    search: `?fileUrl=${e.examId.solution}`
                                                                }}
                                                            >
                                                                <button className="btn btn-sm">View</button>
                                                            </Link>
                                                        ) : null
                                                    ) : (
                                                        <p>NA</p>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={`tab-pane fade ${activeTab === "pills-customExam" ? "show active" : ""}`}>
                    <CustomExam
                        dynamicExams={dynamicExams}
                        dynamicLoading={dynamicLoading}
                        userData={userData}
                        pagination={dynamicPagination}
                        onPageChange={getDynamicExams}
                        currentType={currentExamType}
                    />
                </div>
                <div className={`tab-pane fade ${activeTab === "pills-flexi" ? "show active" : ""}`}>
                    <NeetFlexi
                        dynamicExams={dynamicExams}
                        dynamicLoading={dynamicLoading}
                        userData={userData}
                        pagination={dynamicPagination}
                        onPageChange={getDynamicExams}
                        currentType={currentExamType}
                        />

                </div>
                <div className={`tab-pane fade ${activeTab === "pills-material" ? "show active" : ""}`}>
                    <div className='mt-3'>
                        <table>
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>View</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !materialsLoading && materials.length < 1 &&
                                    <tr><td colSpan={6}><h6>Material will show here once you purchase full Test Series course</h6></td></tr>
                                }
                                {
                                    materialsLoading &&
                                    <tr>
                                        <td colSpan={5}>
                                            <MagnifyingGlass
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="magnifying-glass-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="magnifying-glass-wrapper"
                                                glassColor="#c0efff"
                                                color="#8000df"
                                            />
                                        </td>
                                    </tr>
                                }
                            {
                                !materialsLoading&&materials.length > 0 &&
                                materials.map((s, i) =>
                                        <tr key={i}>
                                            <td>{s.title}</td>
                                            <td>
                                                <Link
                                                    to={{
                                                        pathname: '/view-material',
                                                        // search: `?fileUrl=${encodeURIComponent(`${process.env.REACT_APP_API_URL}${s.fileUrl}`)}`
                                                        search: `?fileUrl=${`${s.file}`}`
                                                    }}
                                                >
                                                    <button className="btn btn-sm">View</button>
                                                </Link>
                                            </td>
                                        </tr>
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={`tab-pane fade ${activeTab === "pills-profile" ? "show active" : ""}`}>
                    <Profile userData={userData} /></div>
                <div className="tab-pane fade" id="pills-question-paper" role="tabpanel" aria-labelledby="pills-question-paper-tab">
                    <div className='mt-3'>
                        <table>
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>View</td>
                                </tr>
                            </thead>
                            {
                                questionPaper.map((s, i) =>
                                    <tbody key={i}>
                                        <tr>
                                            <td>{s.examName}</td>
                                            <td>
                                                <Link
                                                    to={{
                                                        pathname: '/view-solution',
                                                        // search: `?fileUrl=${encodeURIComponent(`${process.env.REACT_APP_API_URL}${s.fileUrl}`)}`
                                                        search: `?fileUrl=${`${s.fileUrl}`}`
                                                    }}
                                                >
                                                    <button className="btn btn-sm">View</button>
                                                </Link>
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            }
                        </table>
                    </div>
                </div>
                <div className="tab-pane fade" id="pills-solution" role="tabpanel" aria-labelledby="pills-solution-tab"><StudentSolutions solutions={solution} /></div>
            </div>
        </nav>
    )
}

export default Nav
